module.exports = __webpack_public_path__ + "assets/img/pages/partners/chalmers-color.png";